import React from 'react';
import * as ROUTES from '../../../../router/Routes';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelUsuariosView from './PanelUsuariosView';

const PanelUsuEntidadesModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.panelUsuEntidades}
      routes={[ROUTES.usuEntidades]}
    >
      <PanelUsuariosView />
    </ContainerTemplate>
  );
};

export default PanelUsuEntidadesModule;
